module.exports = __webpack_public_path__ + "fonts/MicrogrammaD-MediExte.70b0f93.woff2";